"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[98],{

/***/ 76684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ CountryField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56817);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71232);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95117);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1985);
/* harmony import */ var _tabler_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63991);
/* harmony import */ var _core_data_countries_list__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84738);








var useStyles = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .createStyles */ .k)(function(theme) {
    return {
        selectCountry: {
            position: "relative",
            "input": {
                height: "auto",
                paddingTop: 40,
                paddingBottom: 4,
                fontSize: 14
            },
            "& .mantine-Input-icon": {
                top: 38,
                fontSize: 20
            },
            "label": {
                position: "absolute",
                pointerEvents: "none",
                fontSize: theme.fontSizes.sm,
                paddingLeft: theme.spacing.sm,
                paddingTop: 20 / 2,
                zIndex: 1
            },
            "& .mantine-Select-description": {
                position: "absolute",
                pointerEvents: "none",
                fontSize: theme.fontSizes.xs,
                paddingLeft: theme.spacing.sm,
                paddingTop: 28,
                zIndex: 1,
                color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
            },
            "& .mantine-Select-input::placeholder": {
                color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
            },
            "& .mantine-InputWrapper-error": {
                fontSize: 12,
                paddingTop: 6
            }
        }
    };
});
var CountryField = function(param) {
    var value = param.value, variable = param.variable, form = param.form, defaultValue = param.defaultValue, errorMsg = param.errorMsg, fieldLabel = param.fieldLabel, placeholder = param.placeholder, description = param.description, inputVariant = param.inputVariant, required = param.required, disabled = param.disabled, searchable = param.searchable, clearable = param.clearable, onChange = param.onChange;
    var classes = useStyles().classes;
    var SelectItem = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
        var label = _param.label, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
            "label"
        ]);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            ref: ref
        }, others), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Group */ .Z, {
                noWrap: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .x, {
                        size: "sm",
                        children: label
                    })
                })
            })
        }));
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Select */ .Ph, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: classes.selectCountry,
        mt: "sm",
        radius: "xs",
        value: value,
        onChange: onChange,
        itemComponent: SelectItem,
        defaultValue: defaultValue,
        label: fieldLabel,
        placeholder: placeholder,
        description: description,
        error: errorMsg,
        required: required,
        disabled: disabled,
        variant: inputVariant,
        searchable: searchable,
        clearable: clearable,
        allowDeselect: true,
        nothingFound: "No options",
        // rightSection={<IconChevronDown size={14} />}
        // rightSectionWidth={30}
        maxDropdownHeight: 400,
        transition: "pop-top-left",
        transitionDuration: 80,
        transitionTimingFunction: "ease",
        /*getCreateLabel={(query) => `+ Create ${query}`}
            onCreate={(query) => {
                const item = { value: query, label: query };
                setData((current) => [...current, item]);
                return item;
            }}*/ data: _core_data_countries_list__WEBPACK_IMPORTED_MODULE_2__/* .CountriesList.map */ .$.map(function(country) {
            return {
                label: country.label,
                value: country.label
            };
        }),
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons__WEBPACK_IMPORTED_MODULE_10__/* .IconFlag */ .GyD, {
            size: 16,
            stroke: 1
        })
    }, form.getInputProps(variable)));
};


/***/ }),

/***/ 28270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ EmailField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56817);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80061);
/* harmony import */ var _tabler_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63991);





var useStyles = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_2__/* .createStyles */ .k)(function(theme) {
    return {
        textInput: {
            position: "relative",
            "input": {
                height: "auto",
                paddingTop: 40,
                paddingBottom: 4,
                fontSize: 14
            },
            "& .mantine-Input-icon": {
                top: 38,
                fontSize: 20
            },
            "label": {
                position: "absolute",
                pointerEvents: "none",
                fontSize: theme.fontSizes.sm,
                paddingLeft: theme.spacing.sm,
                paddingTop: 20 / 2,
                zIndex: 1
            },
            "& .mantine-TextInput-description": {
                position: "absolute",
                pointerEvents: "none",
                fontSize: theme.fontSizes.xs,
                paddingLeft: theme.spacing.sm,
                paddingTop: 28,
                zIndex: 1,
                color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
            },
            "& .mantine-TextInput-input::placeholder": {
                color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
            },
            "& .mantine-InputWrapper-error": {
                fontSize: 12,
                paddingTop: 6
            }
        }
    };
});
var EmailField = function(param) {
    var variable = param.variable, form = param.form, defaultValue = param.defaultValue, errorMsg = param.errorMsg, fieldLabel = param.fieldLabel, placeholder = param.placeholder, description = param.description, inputVariant = param.inputVariant, required = param.required, disabled = param.disabled;
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes.textInput,
        mt: "sm",
        radius: "xs",
        label: fieldLabel,
        placeholder: placeholder,
        description: description,
        error: errorMsg,
        required: required,
        disabled: disabled,
        variant: inputVariant,
        defaultValue: defaultValue,
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons__WEBPACK_IMPORTED_MODULE_5__/* .IconAt */ .ZiH, {
            size: 16,
            stroke: 1
        })
    }, form.getInputProps(variable)));
};


/***/ }),

/***/ 16751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ InputField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56817);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80061);
/* harmony import */ var _tabler_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63991);





var useStyles = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_2__/* .createStyles */ .k)(function(theme) {
    return {
        textInput: {
            position: "relative",
            "input": {
                height: "auto",
                paddingTop: 40,
                paddingBottom: 4,
                fontSize: 14
            },
            "& .mantine-Input-icon": {
                top: 38,
                fontSize: 20
            },
            "label": {
                position: "absolute",
                pointerEvents: "none",
                fontSize: theme.fontSizes.sm,
                paddingLeft: theme.spacing.sm,
                paddingTop: 20 / 2,
                zIndex: 1
            },
            "& .mantine-TextInput-description": {
                position: "absolute",
                pointerEvents: "none",
                fontSize: theme.fontSizes.xs,
                paddingLeft: theme.spacing.sm,
                paddingTop: 28,
                zIndex: 1,
                color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
            },
            "& .mantine-TextInput-input::placeholder": {
                color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
            },
            "& .mantine-InputWrapper-error": {
                fontSize: 12,
                paddingTop: 6
            }
        }
    };
});
var InputField = function(param) {
    var variable = param.variable, form = param.form, defaultValue = param.defaultValue, errorMsg = param.errorMsg, fieldLabel = param.fieldLabel, placeholder = param.placeholder, description = param.description, inputVariant = param.inputVariant, required = param.required, disabled = param.disabled;
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes.textInput,
        mt: "sm",
        radius: "xs",
        label: fieldLabel,
        placeholder: placeholder,
        description: description,
        error: errorMsg,
        required: required,
        disabled: disabled,
        variant: inputVariant,
        defaultValue: defaultValue,
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons__WEBPACK_IMPORTED_MODULE_5__/* .IconCursorText */ .PYm, {
            size: 16,
            stroke: 1
        })
    }, form.getInputProps(variable)));
};


/***/ }),

/***/ 58566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ PhoneNumberField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56817);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71232);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95117);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1985);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80061);
/* harmony import */ var _tabler_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(63991);








var useStyles = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_2__/* .createStyles */ .k)(function(theme) {
    var _obj, _obj1, _obj2, _obj3;
    return {
        mainPhone: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            width: "100%"
        }, theme.fn.smallerThan("sm"), {
            flexDirection: "column"
        }),
        selectPhone: (_obj1 = {
            position: "relative",
            width: "calc(100%/3)"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, theme.fn.smallerThan("sm"), {
            width: "100%"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, "input", (_obj = {
            height: "auto",
            paddingTop: 40,
            paddingBottom: 4,
            fontSize: 14
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.fn.largerThan("sm"), {
            borderRight: 0,
            borderBottomRightRadius: 0,
            borderTopRightRadius: 0
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.fn.smallerThan("sm"), {
            borderBottom: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        }), _obj)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, "& .mantine-Input-icon", {
            top: 38,
            fontSize: 20
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, "label", {
            position: "absolute",
            pointerEvents: "none",
            fontSize: theme.fontSizes.sm,
            paddingLeft: theme.spacing.sm,
            paddingTop: 20 / 2,
            zIndex: 1
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, "& .mantine-Select-description", {
            position: "absolute",
            pointerEvents: "none",
            fontSize: theme.fontSizes.xs,
            paddingLeft: theme.spacing.sm,
            paddingTop: 28,
            zIndex: 1,
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, "& .mantine-Select-input::placeholder", {
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, "& .mantine-InputWrapper-error", {
            position: "absolute",
            pointerEvents: "none",
            fontSize: theme.fontSizes.xs,
            left: theme.spacing.sm,
            top: 28,
            zIndex: 1,
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
        }), _obj1),
        textInputPhone: (_obj3 = {
            position: "relative",
            width: "calc(70%)"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, theme.fn.smallerThan("sm"), {
            width: "100%"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, "input", (_obj2 = {
            height: "auto",
            paddingTop: 40,
            paddingBottom: 4,
            fontSize: 14
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj2, theme.fn.largerThan("sm"), {
            borderBottomLeftRadius: 0,
            borderTopLeftRadius: 0
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj2, theme.fn.smallerThan("sm"), {
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            marginTop: -2
        }), _obj2)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, "& .mantine-Input-icon", {
            top: 38,
            fontSize: 20
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, "label", {
            position: "absolute",
            pointerEvents: "none",
            fontSize: theme.fontSizes.sm,
            paddingLeft: theme.spacing.sm,
            paddingTop: 20 / 2,
            zIndex: 1
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, "& .mantine-TextInput-description", {
            position: "absolute",
            pointerEvents: "none",
            fontSize: theme.fontSizes.xs,
            paddingLeft: theme.spacing.sm,
            paddingTop: 28,
            zIndex: 1
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, "& .mantine-InputWrapper-error", {
            position: "absolute",
            pointerEvents: "none",
            fontSize: theme.fontSizes.xs,
            left: theme.spacing.sm,
            top: 28,
            zIndex: 1,
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
        }), _obj3)
    };
});
var PhoneNumberField = function(param) {
    var subCompData = param.subCompData, variable = param.variable, subCompVariable = param.subCompVariable, form = param.form, errorMsg = param.errorMsg, fieldLabel = param.fieldLabel, placeholder = param.placeholder, description = param.description, inputVariant = param.inputVariant, required = param.required, disabled = param.disabled, searchable = param.searchable, clearable = param.clearable, onChange = param.onChange;
    var classes = useStyles().classes;
    var SelectItem = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
        var label = _param.label, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
            "label"
        ]);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            ref: ref
        }, others), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Group */ .Z, {
                noWrap: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .x, {
                        size: "sm",
                        children: label
                    })
                })
            })
        }));
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), codes = ref[0], setCodes = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (subCompData !== null) {
            var data = subCompData === null || subCompData === void 0 ? void 0 : subCompData.map(function(val) {
                return {
                    label: "+ ".concat(val),
                    value: val
                };
            });
            setCodes(data);
        }
    }, [
        subCompData
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Group */ .Z, {
        className: classes.mainPhone,
        noWrap: true,
        spacing: 0,
        position: "left",
        mt: "sm",
        children: [
            subCompVariable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Select */ .Ph, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                className: classes.selectPhone,
                radius: "xs",
                error: errorMsg,
                required: required,
                itemComponent: SelectItem,
                label: "Country Code",
                description: "Please select a code",
                disabled: disabled,
                variant: inputVariant,
                searchable: searchable,
                clearable: clearable,
                nothingFound: "No options",
                maxDropdownHeight: 400,
                transition: "pop-top-left",
                transitionDuration: 80,
                transitionTimingFunction: "ease",
                // data={data}
                data: codes
            }, form.getInputProps(subCompVariable))),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                className: classes.textInputPhone,
                radius: "xs",
                type: "number",
                label: fieldLabel,
                placeholder: placeholder,
                description: description,
                disabled: disabled,
                variant: inputVariant,
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons__WEBPACK_IMPORTED_MODULE_11__/* .IconPhoneCall */ .vfA, {
                    size: 16,
                    stroke: 1
                })
            }, form.getInputProps(variable)))
        ]
    });
};


/***/ }),

/***/ 84738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ CountriesList; }
/* harmony export */ });
var CountriesList = [
    {
        "label": "Afghanistan",
        "callingCodes": [
            "93"
        ]
    },
    {
        "label": "\xc5land Islands",
        "callingCodes": [
            "358"
        ]
    },
    {
        "label": "Albania",
        "callingCodes": [
            "355"
        ]
    },
    {
        "label": "Algeria",
        "callingCodes": [
            "213"
        ]
    },
    {
        "label": "American Samoa",
        "callingCodes": [
            "1684"
        ]
    },
    {
        "label": "Andorra",
        "callingCodes": [
            "376"
        ]
    },
    {
        "label": "Angola",
        "callingCodes": [
            "244"
        ]
    },
    {
        "label": "Anguilla",
        "callingCodes": [
            "1264"
        ]
    },
    {
        "label": "Antarctica",
        "callingCodes": [
            "672"
        ]
    },
    {
        "label": "Antigua and Barbuda",
        "callingCodes": [
            "1268"
        ]
    },
    {
        "label": "Argentina",
        "callingCodes": [
            "54"
        ]
    },
    {
        "label": "Armenia",
        "callingCodes": [
            "374"
        ]
    },
    {
        "label": "Aruba",
        "callingCodes": [
            "297"
        ]
    },
    {
        "label": "Australia",
        "callingCodes": [
            "61"
        ]
    },
    {
        "label": "Austria",
        "callingCodes": [
            "43"
        ]
    },
    {
        "label": "Azerbaijan",
        "callingCodes": [
            "994"
        ]
    },
    {
        "label": "Bahamas",
        "callingCodes": [
            "1242"
        ]
    },
    {
        "label": "Bahrain",
        "callingCodes": [
            "973"
        ]
    },
    {
        "label": "Bangladesh",
        "callingCodes": [
            "880"
        ]
    },
    {
        "label": "Barbados",
        "callingCodes": [
            "1246"
        ]
    },
    {
        "label": "Belarus",
        "callingCodes": [
            "375"
        ]
    },
    {
        "label": "Belgium",
        "callingCodes": [
            "32"
        ]
    },
    {
        "label": "Belize",
        "callingCodes": [
            "501"
        ]
    },
    {
        "label": "Benin",
        "callingCodes": [
            "229"
        ]
    },
    {
        "label": "Bermuda",
        "callingCodes": [
            "1441"
        ]
    },
    {
        "label": "Bhutan",
        "callingCodes": [
            "975"
        ]
    },
    {
        "label": "Bolivia (Plurinational State of)",
        "callingCodes": [
            "591"
        ]
    },
    {
        "label": "Bonaire, Sint Eustatius and Saba",
        "callingCodes": [
            "5997"
        ]
    },
    {
        "label": "Bosnia and Herzegovina",
        "callingCodes": [
            "387"
        ]
    },
    {
        "label": "Botswana",
        "callingCodes": [
            "267"
        ]
    },
    {
        "label": "Bouvet Island",
        "callingCodes": [
            ""
        ]
    },
    {
        "label": "Brazil",
        "callingCodes": [
            "55"
        ]
    },
    {
        "label": "British Indian Ocean Territory",
        "callingCodes": [
            "246"
        ]
    },
    {
        "label": "United States Minor Outlying Islands",
        "callingCodes": [
            ""
        ]
    },
    {
        "label": "Virgin Islands (British)",
        "callingCodes": [
            "1284"
        ]
    },
    {
        "label": "Virgin Islands (U.S.)",
        "callingCodes": [
            "1 340"
        ]
    },
    {
        "label": "Brunei Darussalam",
        "callingCodes": [
            "673"
        ]
    },
    {
        "label": "Bulgaria",
        "callingCodes": [
            "359"
        ]
    },
    {
        "label": "Burkina Faso",
        "callingCodes": [
            "226"
        ]
    },
    {
        "label": "Burundi",
        "callingCodes": [
            "257"
        ]
    },
    {
        "label": "Cambodia",
        "callingCodes": [
            "855"
        ]
    },
    {
        "label": "Cameroon",
        "callingCodes": [
            "237"
        ]
    },
    {
        "label": "Canada",
        "callingCodes": [
            "1"
        ]
    },
    {
        "label": "Cabo Verde",
        "callingCodes": [
            "238"
        ]
    },
    {
        "label": "Cayman Islands",
        "callingCodes": [
            "1345"
        ]
    },
    {
        "label": "Central African Republic",
        "callingCodes": [
            "236"
        ]
    },
    {
        "label": "Chad",
        "callingCodes": [
            "235"
        ]
    },
    {
        "label": "Chile",
        "callingCodes": [
            "56"
        ]
    },
    {
        "label": "China",
        "callingCodes": [
            "86"
        ]
    },
    {
        "label": "Christmas Island",
        "callingCodes": [
            "61"
        ]
    },
    {
        "label": "Cocos (Keeling) Islands",
        "callingCodes": [
            "61"
        ]
    },
    {
        "label": "Colombia",
        "callingCodes": [
            "57"
        ]
    },
    {
        "label": "Comoros",
        "callingCodes": [
            "269"
        ]
    },
    {
        "label": "Congo",
        "callingCodes": [
            "242"
        ]
    },
    {
        "label": "Congo (Democratic Republic of the)",
        "callingCodes": [
            "243"
        ]
    },
    {
        "label": "Cook Islands",
        "callingCodes": [
            "682"
        ]
    },
    {
        "label": "Costa Rica",
        "callingCodes": [
            "506"
        ]
    },
    {
        "label": "Croatia",
        "callingCodes": [
            "385"
        ]
    },
    {
        "label": "Cuba",
        "callingCodes": [
            "53"
        ]
    },
    {
        "label": "Cura\xe7ao",
        "callingCodes": [
            "599"
        ]
    },
    {
        "label": "Cyprus",
        "callingCodes": [
            "357"
        ]
    },
    {
        "label": "Czech Republic",
        "callingCodes": [
            "420"
        ]
    },
    {
        "label": "Denmark",
        "callingCodes": [
            "45"
        ]
    },
    {
        "label": "Djibouti",
        "callingCodes": [
            "253"
        ]
    },
    {
        "label": "Dominica",
        "callingCodes": [
            "1767"
        ]
    },
    {
        "label": "Dominican Republic",
        "callingCodes": [
            "1809",
            "1829",
            "1849"
        ]
    },
    {
        "label": "Ecuador",
        "callingCodes": [
            "593"
        ]
    },
    {
        "label": "Egypt",
        "callingCodes": [
            "20"
        ]
    },
    {
        "label": "El Salvador",
        "callingCodes": [
            "503"
        ]
    },
    {
        "label": "Equatorial Guinea",
        "callingCodes": [
            "240"
        ]
    },
    {
        "label": "Eritrea",
        "callingCodes": [
            "291"
        ]
    },
    {
        "label": "Estonia",
        "callingCodes": [
            "372"
        ]
    },
    {
        "label": "Ethiopia",
        "callingCodes": [
            "251"
        ]
    },
    {
        "label": "Falkland Islands (Malvinas)",
        "callingCodes": [
            "500"
        ]
    },
    {
        "label": "Faroe Islands",
        "callingCodes": [
            "298"
        ]
    },
    {
        "label": "Fiji",
        "callingCodes": [
            "679"
        ]
    },
    {
        "label": "Finland",
        "callingCodes": [
            "358"
        ]
    },
    {
        "label": "France",
        "callingCodes": [
            "33"
        ]
    },
    {
        "label": "French Guiana",
        "callingCodes": [
            "594"
        ]
    },
    {
        "label": "French Polynesia",
        "callingCodes": [
            "689"
        ]
    },
    {
        "label": "French Southern Territories",
        "callingCodes": [
            ""
        ]
    },
    {
        "label": "Gabon",
        "callingCodes": [
            "241"
        ]
    },
    {
        "label": "Gambia",
        "callingCodes": [
            "220"
        ]
    },
    {
        "label": "Georgia",
        "callingCodes": [
            "995"
        ]
    },
    {
        "label": "Germany",
        "callingCodes": [
            "49"
        ]
    },
    {
        "label": "Ghana",
        "callingCodes": [
            "233"
        ]
    },
    {
        "label": "Gibraltar",
        "callingCodes": [
            "350"
        ]
    },
    {
        "label": "Greece",
        "callingCodes": [
            "30"
        ]
    },
    {
        "label": "Greenland",
        "callingCodes": [
            "299"
        ]
    },
    {
        "label": "Grenada",
        "callingCodes": [
            "1473"
        ]
    },
    {
        "label": "Guadeloupe",
        "callingCodes": [
            "590"
        ]
    },
    {
        "label": "Guam",
        "callingCodes": [
            "1671"
        ]
    },
    {
        "label": "Guatemala",
        "callingCodes": [
            "502"
        ]
    },
    {
        "label": "Guernsey",
        "callingCodes": [
            "44"
        ]
    },
    {
        "label": "Guinea",
        "callingCodes": [
            "224"
        ]
    },
    {
        "label": "Guinea-Bissau",
        "callingCodes": [
            "245"
        ]
    },
    {
        "label": "Guyana",
        "callingCodes": [
            "592"
        ]
    },
    {
        "label": "Haiti",
        "callingCodes": [
            "509"
        ]
    },
    {
        "label": "Heard Island and McDonald Islands",
        "callingCodes": [
            ""
        ]
    },
    {
        "label": "Holy See",
        "callingCodes": [
            "379"
        ]
    },
    {
        "label": "Honduras",
        "callingCodes": [
            "504"
        ]
    },
    {
        "label": "Hong Kong",
        "callingCodes": [
            "852"
        ]
    },
    {
        "label": "Hungary",
        "callingCodes": [
            "36"
        ]
    },
    {
        "label": "Iceland",
        "callingCodes": [
            "354"
        ]
    },
    {
        "label": "India",
        "callingCodes": [
            "91"
        ]
    },
    {
        "label": "Indonesia",
        "callingCodes": [
            "62"
        ]
    },
    {
        "label": "C\xf4te d'Ivoire",
        "callingCodes": [
            "225"
        ]
    },
    {
        "label": "Iran (Islamic Republic of)",
        "callingCodes": [
            "98"
        ]
    },
    {
        "label": "Iraq",
        "callingCodes": [
            "964"
        ]
    },
    {
        "label": "Ireland",
        "callingCodes": [
            "353"
        ]
    },
    {
        "label": "Isle of Man",
        "callingCodes": [
            "44"
        ]
    },
    {
        "label": "Israel",
        "callingCodes": [
            "972"
        ]
    },
    {
        "label": "Italy",
        "callingCodes": [
            "39"
        ]
    },
    {
        "label": "Jamaica",
        "callingCodes": [
            "1876"
        ]
    },
    {
        "label": "Japan",
        "callingCodes": [
            "81"
        ]
    },
    {
        "label": "Jersey",
        "callingCodes": [
            "44"
        ]
    },
    {
        "label": "Jordan",
        "callingCodes": [
            "962"
        ]
    },
    {
        "label": "Kazakhstan",
        "callingCodes": [
            "76",
            "77"
        ]
    },
    {
        "label": "Kenya",
        "callingCodes": [
            "254"
        ]
    },
    {
        "label": "Kiribati",
        "callingCodes": [
            "686"
        ]
    },
    {
        "label": "Kuwait",
        "callingCodes": [
            "965"
        ]
    },
    {
        "label": "Kyrgyzstan",
        "callingCodes": [
            "996"
        ]
    },
    {
        "label": "Lao People's Democratic Republic",
        "callingCodes": [
            "856"
        ]
    },
    {
        "label": "Latvia",
        "callingCodes": [
            "371"
        ]
    },
    {
        "label": "Lebanon",
        "callingCodes": [
            "961"
        ]
    },
    {
        "label": "Lesotho",
        "callingCodes": [
            "266"
        ]
    },
    {
        "label": "Liberia",
        "callingCodes": [
            "231"
        ]
    },
    {
        "label": "Libya",
        "callingCodes": [
            "218"
        ]
    },
    {
        "label": "Liechtenstein",
        "callingCodes": [
            "423"
        ]
    },
    {
        "label": "Lithuania",
        "callingCodes": [
            "370"
        ]
    },
    {
        "label": "Luxembourg",
        "callingCodes": [
            "352"
        ]
    },
    {
        "label": "Macao",
        "callingCodes": [
            "853"
        ]
    },
    {
        "label": "Macedonia (the former Yugoslav Republic of)",
        "callingCodes": [
            "389"
        ]
    },
    {
        "label": "Madagascar",
        "callingCodes": [
            "261"
        ]
    },
    {
        "label": "Malawi",
        "callingCodes": [
            "265"
        ]
    },
    {
        "label": "Malaysia",
        "callingCodes": [
            "60"
        ]
    },
    {
        "label": "Maldives",
        "callingCodes": [
            "960"
        ]
    },
    {
        "label": "Mali",
        "callingCodes": [
            "223"
        ]
    },
    {
        "label": "Malta",
        "callingCodes": [
            "356"
        ]
    },
    {
        "label": "Marshall Islands",
        "callingCodes": [
            "692"
        ]
    },
    {
        "label": "Martinique",
        "callingCodes": [
            "596"
        ]
    },
    {
        "label": "Mauritania",
        "callingCodes": [
            "222"
        ]
    },
    {
        "label": "Mauritius",
        "callingCodes": [
            "230"
        ]
    },
    {
        "label": "Mayotte",
        "callingCodes": [
            "262"
        ]
    },
    {
        "label": "Mexico",
        "callingCodes": [
            "52"
        ]
    },
    {
        "label": "Micronesia (Federated States of)",
        "callingCodes": [
            "691"
        ]
    },
    {
        "label": "Moldova (Republic of)",
        "callingCodes": [
            "373"
        ]
    },
    {
        "label": "Monaco",
        "callingCodes": [
            "377"
        ]
    },
    {
        "label": "Mongolia",
        "callingCodes": [
            "976"
        ]
    },
    {
        "label": "Montenegro",
        "callingCodes": [
            "382"
        ]
    },
    {
        "label": "Montserrat",
        "callingCodes": [
            "1664"
        ]
    },
    {
        "label": "Morocco",
        "callingCodes": [
            "212"
        ]
    },
    {
        "label": "Mozambique",
        "callingCodes": [
            "258"
        ]
    },
    {
        "label": "Myanmar",
        "callingCodes": [
            "95"
        ]
    },
    {
        "label": "Namibia",
        "callingCodes": [
            "264"
        ]
    },
    {
        "label": "Nauru",
        "callingCodes": [
            "674"
        ]
    },
    {
        "label": "Nepal",
        "callingCodes": [
            "977"
        ]
    },
    {
        "label": "Netherlands",
        "callingCodes": [
            "31"
        ]
    },
    {
        "label": "New Caledonia",
        "callingCodes": [
            "687"
        ]
    },
    {
        "label": "New Zealand",
        "callingCodes": [
            "64"
        ]
    },
    {
        "label": "Nicaragua",
        "callingCodes": [
            "505"
        ]
    },
    {
        "label": "Niger",
        "callingCodes": [
            "227"
        ]
    },
    {
        "label": "Nigeria",
        "callingCodes": [
            "234"
        ]
    },
    {
        "label": "Niue",
        "callingCodes": [
            "683"
        ]
    },
    {
        "label": "Norfolk Island",
        "callingCodes": [
            "672"
        ]
    },
    {
        "label": "Korea (Democratic People's Republic of)",
        "callingCodes": [
            "850"
        ]
    },
    {
        "label": "Northern Mariana Islands",
        "callingCodes": [
            "1670"
        ]
    },
    {
        "label": "Norway",
        "callingCodes": [
            "47"
        ]
    },
    {
        "label": "Oman",
        "callingCodes": [
            "968"
        ]
    },
    {
        "label": "Pakistan",
        "callingCodes": [
            "92"
        ]
    },
    {
        "label": "Palau",
        "callingCodes": [
            "680"
        ]
    },
    {
        "label": "Palestine, State of",
        "callingCodes": [
            "970"
        ]
    },
    {
        "label": "Panama",
        "callingCodes": [
            "507"
        ]
    },
    {
        "label": "Papua New Guinea",
        "callingCodes": [
            "675"
        ]
    },
    {
        "label": "Paraguay",
        "callingCodes": [
            "595"
        ]
    },
    {
        "label": "Peru",
        "callingCodes": [
            "51"
        ]
    },
    {
        "label": "Philippines",
        "callingCodes": [
            "63"
        ]
    },
    {
        "label": "Pitcairn",
        "callingCodes": [
            "64"
        ]
    },
    {
        "label": "Poland",
        "callingCodes": [
            "48"
        ]
    },
    {
        "label": "Portugal",
        "callingCodes": [
            "351"
        ]
    },
    {
        "label": "Puerto Rico",
        "callingCodes": [
            "1787",
            "1939"
        ]
    },
    {
        "label": "Qatar",
        "callingCodes": [
            "974"
        ]
    },
    {
        "label": "Republic of Kosovo",
        "callingCodes": [
            "383"
        ]
    },
    {
        "label": "R\xe9union",
        "callingCodes": [
            "262"
        ]
    },
    {
        "label": "Romania",
        "callingCodes": [
            "40"
        ]
    },
    {
        "label": "Russian Federation",
        "callingCodes": [
            "7"
        ]
    },
    {
        "label": "Rwanda",
        "callingCodes": [
            "250"
        ]
    },
    {
        "label": "Saint Barth\xe9lemy",
        "callingCodes": [
            "590"
        ]
    },
    {
        "label": "Saint Helena, Ascension and Tristan da Cunha",
        "callingCodes": [
            "290"
        ]
    },
    {
        "label": "Saint Kitts and Nevis",
        "callingCodes": [
            "1869"
        ]
    },
    {
        "label": "Saint Lucia",
        "callingCodes": [
            "1758"
        ]
    },
    {
        "label": "Saint Martin (French part)",
        "callingCodes": [
            "590"
        ]
    },
    {
        "label": "Saint Pierre and Miquelon",
        "callingCodes": [
            "508"
        ]
    },
    {
        "label": "Saint Vincent and the Grenadines",
        "callingCodes": [
            "1784"
        ]
    },
    {
        "label": "Samoa",
        "callingCodes": [
            "685"
        ]
    },
    {
        "label": "San Marino",
        "callingCodes": [
            "378"
        ]
    },
    {
        "label": "Sao Tome and Principe",
        "callingCodes": [
            "239"
        ]
    },
    {
        "label": "Saudi Arabia",
        "callingCodes": [
            "966"
        ]
    },
    {
        "label": "Senegal",
        "callingCodes": [
            "221"
        ]
    },
    {
        "label": "Serbia",
        "callingCodes": [
            "381"
        ]
    },
    {
        "label": "Seychelles",
        "callingCodes": [
            "248"
        ]
    },
    {
        "label": "Sierra Leone",
        "callingCodes": [
            "232"
        ]
    },
    {
        "label": "Singapore",
        "callingCodes": [
            "65"
        ]
    },
    {
        "label": "Sint Maarten (Dutch part)",
        "callingCodes": [
            "1721"
        ]
    },
    {
        "label": "Slovakia",
        "callingCodes": [
            "421"
        ]
    },
    {
        "label": "Slovenia",
        "callingCodes": [
            "386"
        ]
    },
    {
        "label": "Solomon Islands",
        "callingCodes": [
            "677"
        ]
    },
    {
        "label": "Somalia",
        "callingCodes": [
            "252"
        ]
    },
    {
        "label": "South Africa",
        "callingCodes": [
            "27"
        ]
    },
    {
        "label": "South Georgia and the South Sandwich Islands",
        "callingCodes": [
            "500"
        ]
    },
    {
        "label": "Korea (Republic of)",
        "callingCodes": [
            "82"
        ]
    },
    {
        "label": "South Sudan",
        "callingCodes": [
            "211"
        ]
    },
    {
        "label": "Spain",
        "callingCodes": [
            "34"
        ]
    },
    {
        "label": "Sri Lanka",
        "callingCodes": [
            "94"
        ]
    },
    {
        "label": "Sudan",
        "callingCodes": [
            "249"
        ]
    },
    {
        "label": "Surilabel",
        "callingCodes": [
            "597"
        ]
    },
    {
        "label": "Svalbard and Jan Mayen",
        "callingCodes": [
            "4779"
        ]
    },
    {
        "label": "Swaziland",
        "callingCodes": [
            "268"
        ]
    },
    {
        "label": "Sweden",
        "callingCodes": [
            "46"
        ]
    },
    {
        "label": "Switzerland",
        "callingCodes": [
            "41"
        ]
    },
    {
        "label": "Syrian Arab Republic",
        "callingCodes": [
            "963"
        ]
    },
    {
        "label": "Taiwan",
        "callingCodes": [
            "886"
        ]
    },
    {
        "label": "Tajikistan",
        "callingCodes": [
            "992"
        ]
    },
    {
        "label": "Tanzania, United Republic of",
        "callingCodes": [
            "255"
        ]
    },
    {
        "label": "Thailand",
        "callingCodes": [
            "66"
        ]
    },
    {
        "label": "Timor-Leste",
        "callingCodes": [
            "670"
        ]
    },
    {
        "label": "Togo",
        "callingCodes": [
            "228"
        ]
    },
    {
        "label": "Tokelau",
        "callingCodes": [
            "690"
        ]
    },
    {
        "label": "Tonga",
        "callingCodes": [
            "676"
        ]
    },
    {
        "label": "Trinidad and Tobago",
        "callingCodes": [
            "1868"
        ]
    },
    {
        "label": "Tunisia",
        "callingCodes": [
            "216"
        ]
    },
    {
        "label": "Turkey",
        "callingCodes": [
            "90"
        ]
    },
    {
        "label": "Turkmenistan",
        "callingCodes": [
            "993"
        ]
    },
    {
        "label": "Turks and Caicos Islands",
        "callingCodes": [
            "1649"
        ]
    },
    {
        "label": "Tuvalu",
        "callingCodes": [
            "688"
        ]
    },
    {
        "label": "Uganda",
        "callingCodes": [
            "256"
        ]
    },
    {
        "label": "Ukraine",
        "callingCodes": [
            "380"
        ]
    },
    {
        "label": "United Arab Emirates",
        "callingCodes": [
            "971"
        ]
    },
    {
        "label": "United Kingdom of Great Britain and Northern Ireland",
        "callingCodes": [
            "44"
        ]
    },
    {
        "label": "United States of America",
        "callingCodes": [
            "1"
        ]
    },
    {
        "label": "Uruguay",
        "callingCodes": [
            "598"
        ]
    },
    {
        "label": "Uzbekistan",
        "callingCodes": [
            "998"
        ]
    },
    {
        "label": "Vanuatu",
        "callingCodes": [
            "678"
        ]
    },
    {
        "label": "Venezuela (Bolivarian Republic of)",
        "callingCodes": [
            "58"
        ]
    },
    {
        "label": "Viet Nam",
        "callingCodes": [
            "84"
        ]
    },
    {
        "label": "Wallis and Futuna",
        "callingCodes": [
            "681"
        ]
    },
    {
        "label": "Western Sahara",
        "callingCodes": [
            "212"
        ]
    },
    {
        "label": "Yemen",
        "callingCodes": [
            "967"
        ]
    },
    {
        "label": "Zambia",
        "callingCodes": [
            "260"
        ]
    },
    {
        "label": "Zimbabwe",
        "callingCodes": [
            "263"
        ]
    }
];


/***/ })

}]);